import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { patchesActionTypes } from '../reducer';

function* fetchPhones() {
  yield requestSaga({
    actionType: patchesActionTypes.getList,
    request: dataProvider.getList,
    resource: resources.patch.list,
  });
}

export default fetchPhones;
